/**
 * Blog types and constants
 */

export type CategorySlug =
  | "early-coding"
  | "screen-time"
  | "kindergarten-readiness"
  | "play-based-learning";

export interface BlogFrontmatter {
  title: string;
  description: string;
  date: string;
  author: string;
  category: CategorySlug;
  tags: string[];
  published: boolean;
  image?: string;
  imageAlt?: string;
}

export interface BlogPost {
  slug: string;
  category: CategorySlug;
  frontmatter: BlogFrontmatter;
  Content: React.ComponentType<{
    components?: Record<string, React.ComponentType>;
  }>;
}

export interface Category {
  slug: CategorySlug;
  name: string;
  description: string;
  color: string;
}

export const CATEGORIES: Category[] = [
  {
    slug: "early-coding",
    name: "Early Coding",
    description: "Coding and computational thinking for preschoolers",
    color: "pixel",
  },
  {
    slug: "screen-time",
    name: "Screen Time",
    description: "Making screen time educational and guilt-free",
    color: "magic",
  },
  {
    slug: "kindergarten-readiness",
    name: "Kindergarten Readiness",
    description: "Getting ready for kindergarten",
    color: "sunshine",
  },
  {
    slug: "play-based-learning",
    name: "Play-Based Learning",
    description: "The science and practice of play-based learning",
    color: "meadow",
  },
];

export function getCategoryBySlug(slug: string): Category | undefined {
  return CATEGORIES.find((c) => c.slug === slug);
}

/**
 * Calculate estimated reading time based on word count
 */
export function calculateReadingTime(content: string): number {
  const wordsPerMinute = 200;
  const words = content.trim().split(/\s+/).length;
  return Math.ceil(words / wordsPerMinute);
}
